import * as React from 'react';
import { FC } from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

import { RewardsCarouselCard } from './rewards-carousel-card';
import { RewardsCarouselContainer } from './rewards-carousel.styled';
import { IRewardsCarouselProps } from './types';

/**
 * A carousel for loyalty rewards
 */
const RewardsCarousel: FC<IRewardsCarouselProps> = ({ rewards, className, children }) => (
  <RewardsCarouselContainer className={className}>
    <ResponsiveCarousel bgColor="transparent">
      {rewards
        ? rewards.map(reward => <RewardsCarouselCard reward={reward} key={reward._id} />)
        : (children as React.ReactNode[])}
    </ResponsiveCarousel>
  </RewardsCarouselContainer>
);

export default RewardsCarousel;
